import styles from "./AndroidLarge25.module.css";

const AndroidLarge25 = () => {
  return (
    <div className={styles.androidLarge25}>
      <div className={styles.androidLarge25Child} />
      <div className={styles.rectangleParent}>
        <div className={styles.groupChild} />
        <img className={styles.vectorIcon} alt="" src="/vector4.svg" />
      </div>
      <div className={styles.groupParent}>
        <div className={styles.rectangleGroup}>
          <div className={styles.groupItem} />
          <div className={styles.groupInner} />
        </div>
        <img className={styles.vectorIcon1} alt="" src="/vector5.svg" />
      </div>
      <div className={styles.rectangleContainer}>
        <div className={styles.rectangleDiv} />
        <img className={styles.vectorIcon2} alt="" src="/vector6.svg" />
      </div>
      <div className={styles.frameParent}>
        <div className={styles.rectangleWrapper}>
          <div className={styles.frameChild} />
        </div>
        <img className={styles.frameIcon} alt="" src="/frame-48096294.svg" />
      </div>
      <div className={styles.androidLarge25Inner}>
        <div className={styles.groupChild1} />
      </div>
      <div className={styles.beautifulPurpleUniverseBackParent}>
        <img
          className={styles.beautifulPurpleUniverseBackIcon}
          alt=""
          src="/beautifulpurpleuniversebackground-11@2x.png"
        />
        <div className={styles.groupChild2} />
      </div>
      <div className={styles.frameGroup}>
        <div className={styles.astrologyForClarityParent}>
          <b className={styles.astrologyForClarity}>“Astrology for Clarity”</b>
          <div
            className={styles.yourNameIs}
          >{`Your Name is a Vedic Astrologer and has expertise in Vaastu and Mantra Theraphy `}</div>
        </div>
        <div className={styles.groupWrapper}>
          <div className={styles.groupDiv}>
            <div className={styles.groupChild3} />
            <div className={styles.consultNow}>Consult Now</div>
          </div>
        </div>
      </div>
      <div className={styles.topNavigationBarParent}>
        <img
          className={styles.topNavigationBar}
          alt=""
          src="/top-navigation--bar.svg"
        />
        <div className={styles.groupContainer}>
          <div className={styles.ellipseParent}>
            <img
              className={styles.ellipseIcon}
              alt=""
              src="/ellipse-15511.svg"
            />
            <div className={styles.guruji}>
              <p className={styles.loveRelated}>Guruji</p>
            </div>
            <img className={styles.groupIcon} alt="" src="/group-507781.svg" />
            <img className={styles.layer3Icon} alt="" src="/layer-31.svg" />
            <img className={styles.objectsIcon} alt="" src="/objects1.svg" />
          </div>
        </div>
      </div>
      <div className={styles.frameContainer}>
        <div className={styles.astrologyForClarityParent}>
          <img className={styles.groupIcon1} alt="" src="/group.svg" />
          <div className={styles.vectorParent}>
            <img className={styles.vectorIcon3} alt="" src="/vector7.svg" />
            <b className={styles.userTestimonial}>User Testimonial</b>
            <img className={styles.vectorIcon4} alt="" src="/vector8.svg" />
          </div>
        </div>
        <div className={styles.frameDiv}>
          <img className={styles.frameItem} alt="" src="/group-51345.svg" />
          <img className={styles.frameInner} alt="" src="/group-51346.svg" />
          <img className={styles.frameChild1} alt="" src="/group-51344.svg" />
        </div>
      </div>
      <div className={styles.vectorGroup}>
        <img className={styles.vectorIcon3} alt="" src="/vector7.svg" />
        <b className={styles.userTestimonial}>Premium Astrologers</b>
        <img className={styles.vectorIcon4} alt="" src="/vector8.svg" />
      </div>
      <div className={styles.frameParent1}>
        <div className={styles.groupFrame}>
          <div className={styles.maskGroupParent}>
            <img
              className={styles.maskGroupIcon}
              alt=""
              src="/mask-group8@2x.png"
            />
            <div className={styles.groupChild4} />
            <div className={styles.groupChild5} />
            <div className={styles.groupWrapper1}>
              <div className={styles.frameWrapper}>
                <div className={styles.frameWrapper1}>
                  <div className={styles.frameWrapper2}>
                    <div className={styles.frameWrapper3}>
                      <div className={styles.parent}>
                        <img className={styles.icon} alt="" src="/6.svg" />
                        <div className={styles.div}>4.5</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.div1}>10+ Years</div>
            <div className={styles.groupParent1}>
              <div className={styles.rectangleParent1}>
                <div className={styles.rectangle} />
                <b className={styles.online}>Online</b>
              </div>
              <img
                className={styles.groupChild6}
                alt=""
                src="/ellipse-15284.svg"
              />
            </div>
            <div className={styles.frameParent2}>
              <div className={styles.astrologerRamrajWrapper}>
                <div className={styles.astrologerRamraj}>Astrologer Ramraj</div>
              </div>
              <div className={styles.frameParent3}>
                <div className={styles.group}>
                  <div className={styles.div2}>Specialties</div>
                  <div className={styles.wrapper}>
                    <div className={styles.div3}>{`Love, Business, Life `}</div>
                  </div>
                </div>
                <div className={styles.group}>
                  <div className={styles.div4}>Skills</div>
                  <div
                    className={styles.div5}
                  >{`Vedic Astrology, Kundali, `}</div>
                </div>
              </div>
            </div>
            <div className={styles.parent1}>
              <div className={styles.div3}>Price</div>
              <div className={styles.frameWrapper4}>
                <div className={styles.groupWrapper2}>
                  <div className={styles.statusbusyqueueParent}>
                    <b className={styles.statusbusyqueue}>₹10</b>
                    <b className={styles.min}>/min</b>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.groupParent2}>
              <img
                className={styles.groupChild7}
                alt=""
                src="/group-511338.svg"
              />
              <div className={styles.iconsaxoutlinecallParent}>
                <img
                  className={styles.iconsaxoutlinecall}
                  alt=""
                  src="/iconsaxoutlinecall3.svg"
                />
                <b className={styles.call}>Call</b>
              </div>
              <div className={styles.iconsaxoutlinemessageParent}>
                <img
                  className={styles.iconsaxoutlinecall}
                  alt=""
                  src="/iconsaxoutlinemessage5.svg"
                />
                <b className={styles.call}>Chat</b>
              </div>
            </div>
            <div className={styles.lineDiv} />
            <div className={styles.div7}>4.7</div>
          </div>
        </div>
        <div className={styles.groupFrame}>
          <div className={styles.maskGroupParent}>
            <img
              className={styles.maskGroupIcon}
              alt=""
              src="/mask-group8@2x.png"
            />
            <div className={styles.groupChild4} />
            <div className={styles.groupChild5} />
            <div className={styles.groupWrapper1}>
              <div className={styles.frameWrapper}>
                <div className={styles.frameWrapper1}>
                  <div className={styles.frameWrapper2}>
                    <div className={styles.frameWrapper3}>
                      <div className={styles.parent}>
                        <img className={styles.icon} alt="" src="/6.svg" />
                        <div className={styles.div}>4.5</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.div1}>10+ Years</div>
            <div className={styles.groupParent1}>
              <div className={styles.rectangleParent1}>
                <div className={styles.rectangle} />
                <b className={styles.online}>Online</b>
              </div>
              <img
                className={styles.groupChild6}
                alt=""
                src="/ellipse-15284.svg"
              />
            </div>
            <div className={styles.frameParent2}>
              <div className={styles.astrologerRamrajWrapper}>
                <div className={styles.astrologerRamraj}>Astrologer Ramraj</div>
              </div>
              <div className={styles.frameParent3}>
                <div className={styles.group}>
                  <div className={styles.div2}>Specialties</div>
                  <div className={styles.wrapper}>
                    <div className={styles.div3}>{`Love, Business, Life `}</div>
                  </div>
                </div>
                <div className={styles.group}>
                  <div className={styles.div4}>Skills</div>
                  <div
                    className={styles.div5}
                  >{`Vedic Astrology, Kundali, `}</div>
                </div>
              </div>
            </div>
            <div className={styles.parent1}>
              <div className={styles.div3}>Price</div>
              <div className={styles.frameWrapper4}>
                <div className={styles.groupWrapper2}>
                  <div className={styles.statusbusyqueueParent}>
                    <b className={styles.statusbusyqueue}>₹10</b>
                    <b className={styles.min}>/min</b>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.groupParent2}>
              <img
                className={styles.groupChild7}
                alt=""
                src="/group-511338.svg"
              />
              <div className={styles.iconsaxoutlinecallParent}>
                <img
                  className={styles.iconsaxoutlinecall}
                  alt=""
                  src="/iconsaxoutlinecall4.svg"
                />
                <b className={styles.call}>Call</b>
              </div>
              <div className={styles.iconsaxoutlinemessageParent}>
                <img
                  className={styles.iconsaxoutlinecall}
                  alt=""
                  src="/iconsaxoutlinemessage5.svg"
                />
                <b className={styles.call}>Chat</b>
              </div>
            </div>
            <div className={styles.lineDiv} />
            <div className={styles.div7}>4.7</div>
          </div>
        </div>
      </div>
      <div className={styles.frameParent6}>
        <div className={styles.vectorParent}>
          <img className={styles.vectorIcon3} alt="" src="/vector7.svg" />
          <b className={styles.userTestimonial}>Top Astrologers</b>
          <img className={styles.vectorIcon4} alt="" src="/vector8.svg" />
        </div>
        <div className={styles.frameParent7}>
          <div className={styles.groupFrame}>
            <div className={styles.maskGroupParent}>
              <img
                className={styles.maskGroupIcon}
                alt=""
                src="/mask-group8@2x.png"
              />
              <div className={styles.groupChild4} />
              <div className={styles.groupChild5} />
              <div className={styles.groupWrapper1}>
                <div className={styles.frameWrapper}>
                  <div className={styles.frameWrapper1}>
                    <div className={styles.frameWrapper2}>
                      <div className={styles.frameWrapper3}>
                        <div className={styles.parent}>
                          <img className={styles.icon} alt="" src="/6.svg" />
                          <div className={styles.div}>4.5</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.div1}>10+ Years</div>
              <div className={styles.groupParent1}>
                <div className={styles.rectangleParent1}>
                  <div className={styles.rectangle} />
                  <b className={styles.online}>Online</b>
                </div>
                <img
                  className={styles.groupChild6}
                  alt=""
                  src="/ellipse-15285.svg"
                />
              </div>
              <div className={styles.frameParent2}>
                <div className={styles.astrologerRamrajWrapper}>
                  <div className={styles.astrologerRamraj}>
                    Astrologer Ramraj
                  </div>
                </div>
                <div className={styles.frameParent3}>
                  <div className={styles.group}>
                    <div className={styles.div2}>Specialties</div>
                    <div className={styles.wrapper}>
                      <div
                        className={styles.div3}
                      >{`Love, Business, Life `}</div>
                    </div>
                  </div>
                  <div className={styles.group}>
                    <div className={styles.div4}>Skills</div>
                    <div
                      className={styles.div5}
                    >{`Vedic Astrology, Kundali, `}</div>
                  </div>
                </div>
              </div>
              <div className={styles.parent1}>
                <div className={styles.div3}>Price</div>
                <div className={styles.frameWrapper4}>
                  <div className={styles.groupWrapper2}>
                    <div className={styles.statusbusyqueueParent}>
                      <b className={styles.statusbusyqueue}>₹10</b>
                      <b className={styles.min}>/min</b>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.groupParent2}>
                <img
                  className={styles.groupChild7}
                  alt=""
                  src="/group-511339.svg"
                />
                <div className={styles.iconsaxoutlinecallParent}>
                  <img
                    className={styles.iconsaxoutlinecall}
                    alt=""
                    src="/iconsaxoutlinecall5.svg"
                  />
                  <b className={styles.call}>Call</b>
                </div>
                <div className={styles.iconsaxoutlinemessageParent}>
                  <img
                    className={styles.iconsaxoutlinecall}
                    alt=""
                    src="/iconsaxoutlinemessage6.svg"
                  />
                  <b className={styles.call}>Chat</b>
                </div>
              </div>
              <div className={styles.lineDiv} />
              <div className={styles.div7}>4.7</div>
            </div>
          </div>
          <div className={styles.groupFrame}>
            <div className={styles.maskGroupParent}>
              <img
                className={styles.maskGroupIcon}
                alt=""
                src="/mask-group8@2x.png"
              />
              <div className={styles.groupChild4} />
              <div className={styles.groupChild5} />
              <div className={styles.groupWrapper1}>
                <div className={styles.frameWrapper}>
                  <div className={styles.frameWrapper1}>
                    <div className={styles.frameWrapper2}>
                      <div className={styles.frameWrapper3}>
                        <div className={styles.parent}>
                          <img className={styles.icon} alt="" src="/6.svg" />
                          <div className={styles.div}>4.5</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.div1}>10+ Years</div>
              <div className={styles.groupParent1}>
                <div className={styles.rectangleParent1}>
                  <div className={styles.rectangle} />
                  <b className={styles.online}>Online</b>
                </div>
                <img
                  className={styles.groupChild6}
                  alt=""
                  src="/ellipse-15285.svg"
                />
              </div>
              <div className={styles.frameParent2}>
                <div className={styles.astrologerRamrajWrapper}>
                  <div className={styles.astrologerRamraj}>
                    Astrologer Ramraj
                  </div>
                </div>
                <div className={styles.frameParent3}>
                  <div className={styles.group}>
                    <div className={styles.div2}>Specialties</div>
                    <div className={styles.wrapper}>
                      <div
                        className={styles.div3}
                      >{`Love, Business, Life `}</div>
                    </div>
                  </div>
                  <div className={styles.group}>
                    <div className={styles.div4}>Skills</div>
                    <div
                      className={styles.div5}
                    >{`Vedic Astrology, Kundali, `}</div>
                  </div>
                </div>
              </div>
              <div className={styles.parent1}>
                <div className={styles.div3}>Price</div>
                <div className={styles.frameWrapper4}>
                  <div className={styles.groupWrapper2}>
                    <div className={styles.statusbusyqueueParent}>
                      <b className={styles.statusbusyqueue}>₹10</b>
                      <b className={styles.min}>/min</b>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.groupParent2}>
                <img
                  className={styles.groupChild7}
                  alt=""
                  src="/group-511339.svg"
                />
                <div className={styles.iconsaxoutlinecallParent}>
                  <img
                    className={styles.iconsaxoutlinecall}
                    alt=""
                    src="/iconsaxoutlinecall6.svg"
                  />
                  <b className={styles.call}>Call</b>
                </div>
                <div className={styles.iconsaxoutlinemessageParent}>
                  <img
                    className={styles.iconsaxoutlinecall}
                    alt=""
                    src="/iconsaxoutlinemessage6.svg"
                  />
                  <b className={styles.call}>Chat</b>
                </div>
              </div>
              <div className={styles.lineDiv} />
              <div className={styles.div7}>4.7</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.frameParent12}>
        <div className={styles.vectorParent}>
          <img className={styles.vectorIcon3} alt="" src="/vector9.svg" />
          <b className={styles.userTestimonial}>Many Problem one Solution</b>
          <img className={styles.vectorIcon4} alt="" src="/vector10.svg" />
        </div>
        <img className={styles.frameChild2} alt="" src="/group-51353.svg" />
        <div className={styles.frameParent13}>
          <div className={styles.groupParent9}>
            <div className={styles.rectangleParent5}>
              <div className={styles.groupChild23} />
              <div className={styles.loveRelatedProblemContainer}>
                <p className={styles.loveRelated}>{`Love Related `}</p>
                <p className={styles.loveRelated}>{`Problem `}</p>
              </div>
              <img
                className={styles.groupChild24}
                alt=""
                src="/group-511961.svg"
              />
            </div>
            <div className={styles.rectangleParent6}>
              <div className={styles.groupChild25} />
              <div className={styles.marriageProblem}>Marriage Problem</div>
              <img
                className={styles.groupChild26}
                alt=""
                src="/group-511981.svg"
              />
            </div>
          </div>
          <div className={styles.groupParent9}>
            <div className={styles.rectangleParent5}>
              <div className={styles.groupChild23} />
              <div className={styles.healthProblems}>Health Problems</div>
              <img
                className={styles.groupChild24}
                alt=""
                src="/group-51372.svg"
              />
            </div>
            <div className={styles.rectangleParent5}>
              <div className={styles.groupChild23} />
              <div className={styles.grahShanti}>Grah Shanti</div>
              <img
                className={styles.groupChild24}
                alt=""
                src="/group-51373.svg"
              />
            </div>
          </div>
          <div className={styles.groupParent9}>
            <div className={styles.rectangleParent9}>
              <div className={styles.groupChild31} />
              <img
                className={styles.rectangleIcon}
                alt=""
                src="/rectangle-188071.svg"
              />
              <div className={styles.moneyProblem}>Money Problem</div>
              <img
                className={styles.rupeesCoinsIcon}
                alt=""
                src="/rupees-coins1.svg"
              />
            </div>
            <div className={styles.rectangleParent5}>
              <div className={styles.groupChild23} />
              <div className={styles.educationProblems}>Education Problems</div>
              <img
                className={styles.groupChild24}
                alt=""
                src="/group-512031.svg"
              />
            </div>
          </div>
          <div className={styles.groupParent9}>
            <div className={styles.rectangleParent9}>
              <div className={styles.groupChild31} />
              <div className={styles.husbandWifeProblems}>
                Husband Wife Problems
              </div>
              <img
                className={styles.rectangleIcon}
                alt=""
                src="/group-51375.svg"
              />
            </div>
            <div className={styles.rectangleParent5}>
              <div className={styles.groupChild23} />
              <div className={styles.luckyNumber}>Lucky Number / Color</div>
              <img
                className={styles.groupChild24}
                alt=""
                src="/group-511901.svg"
              />
            </div>
          </div>
          <div className={styles.groupParent9}>
            <div className={styles.rectangleParent13}>
              <div className={styles.groupChild38} />
              <div className={styles.jobbusinessProblems}>
                Job/Business Problems
              </div>
              <img
                className={styles.groupChild39}
                alt=""
                src="/group-512001.svg"
              />
            </div>
            <div className={styles.rectangleParent13}>
              <div className={styles.groupChild38} />
              <div className={styles.childBirthIssues}>Child Birth Issues</div>
              <img
                className={styles.groupChild39}
                alt=""
                src="/group-51374.svg"
              />
            </div>
          </div>
        </div>
      </div>
      <img
        className={styles.trustBanner22}
        alt=""
        src="/trust-banner2-2@2x.png"
      />
      <div className={styles.frameParent14}>
        <div className={styles.vectorParent}>
          <img className={styles.vectorIcon3} alt="" src="/vector9.svg" />
          <b className={styles.userTestimonial}>User Review</b>
          <img className={styles.vectorIcon4} alt="" src="/vector10.svg" />
        </div>
        <div className={styles.groupParent14}>
          <div className={styles.groupWrapper12}>
            <div className={styles.groupWrapper12}>
              <div className={styles.groupChild42} />
              <div className={styles.groupChild43} />
              <div className={styles.groupChild44} />
            </div>
          </div>
          <div className={styles.groupParent15}>
            <div className={styles.frameParent15}>
              <div className={styles.ellipseGroup}>
                <img
                  className={styles.frameChild3}
                  alt=""
                  src="/ellipse-16291@2x.png"
                />
                <img
                  className={styles.frameChild4}
                  alt=""
                  src="/ellipse-16301@2x.png"
                />
                <img
                  className={styles.frameChild4}
                  alt=""
                  src="/ellipse-16311@2x.png"
                />
              </div>
              <div className={styles.ellipseContainer}>
                <img
                  className={styles.frameChild6}
                  alt=""
                  src="/ellipse-16321@2x.png"
                />
                <img
                  className={styles.frameChild7}
                  alt=""
                  src="/ellipse-16331@2x.png"
                />
                <img
                  className={styles.frameChild8}
                  alt=""
                  src="/ellipse-16341@2x.png"
                />
              </div>
              <div className={styles.ellipseParent1}>
                <img
                  className={styles.frameChild9}
                  alt=""
                  src="/ellipse-16281@2x.png"
                />
                <div className={styles.harshPatel}>Harsh Patel</div>
              </div>
            </div>
            <div className={styles.exploreTheMysteriesOfTheUParent}>
              <div
                className={styles.exploreTheMysteries}
              >{`Explore the Mysteries of the Universe with Our Expert Astrology Services Explore the Mysteries of the Universe with Our Expert Astrology ServicesExplore the Mysteries of the Universe with `}</div>
              <div className={styles.parent14}>
                <img className={styles.icon4} alt="" src="/7.svg" />
                <img className={styles.icon4} alt="" src="/8.svg" />
                <img className={styles.icon4} alt="" src="/9.svg" />
                <img className={styles.icon4} alt="" src="/10.svg" />
                <img className={styles.icon4} alt="" src="/111.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <b className={styles.footer}>Footer</b>
      <div className={styles.frameParent16}>
        <div className={styles.groupParent16}>
          <img className={styles.frameChild10} alt="" src="/group-506001.svg" />
          <div className={styles.x7Customer}>24 X 7 Customer Support</div>
        </div>
        <div className={styles.groupParent16}>
          <img className={styles.frameChild11} alt="" src="/group-509981.svg" />
          <div className={styles.refundIfUnsatisfied}>
            100% Refund if Unsatisfied
          </div>
        </div>
        <div className={styles.groupParent16}>
          <img className={styles.frameChild12} alt="" src="/group-506021.svg" />
          <div
            className={styles.privateConfidential}
          >{`Private & Confidential`}</div>
        </div>
        <div className={styles.groupParent16}>
          <img className={styles.frameChild13} alt="" src="/group-506031.svg" />
          <div className={styles.verifiedAstrologer}>Verified Astrologer</div>
        </div>
        <div className={styles.groupParent16}>
          <img className={styles.frameChild14} alt="" src="/group-506041.svg" />
          <div className={styles.securePayment}>Secure Payment</div>
        </div>
      </div>
    </div>
  );
};

export default AndroidLarge25;
